// @flow
import React from 'react'
import { Stink } from 'components/Stink'
import styled from 'styled-components'
import { AutofitIFrame } from '@ta-interaktiv/react-autofit-iframe'
import './styles.scss'

export class Section7 extends React.Component<Props, State> {
  constructor() {
    super()
    this.state = {
    }
    this.updateSizes = this.updateSizes.bind(this)
  }

  updateSizes() {
    this.setState({
      isMobile: window.innerWidth < 711
    })
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateSizes)
    this.updateSizes()
  }

  render() {
    return <div className='section seven'>
       <div className="wrapper">
       <h2>Ce que l'on sait des morsures de chiens</h2>
          <div className='txt'>
            <p>
              Il n'existe pas de base de données nationale sur les cas de morsures. Mais si un chien blesse gravement des personnes ou des animaux, ou si l'animal est particulièrement agressif, cela doit être signalé, en général à l'office vétérinaire cantonal. Une enquête de la télévision alémanique SRF, effectuée auprès de tous les cantons, a montré en 2019 que plus de 7000 incidents impliquant des chiens ont eu lieu dans toute la Suisse. C'était 19% de plus qu'en 2016, soit la dernière année où les cours étaient encore obligatoires dans toute la Suisse pour les propriétaires de chiens. 
            </p>
            <p>
              Aujourd'hui, ces cours ne sont plus obligatoires au niveau national et il existe de grosses disparités régionales. Ainsi, dans certains cantons, l'obligation s'applique uniquement lorsqu'il s'agit du premier chien. Dans d'autres cantons, les propriétaires sont tenus de suivre un cours lorsqu'il s'agit d'animaux présentant un danger potentiel accru ou à partir d'une certaine taille. Selon la télévision alémanique SRF, la moitié des cantons ne connaissent plus d'obligation du tout.
            </p>
          </div>
          <div className="chart">
            <AutofitIFrame
              src={'https://datawrapper.dwcdn.net/hLr6U/1/' + '?dark=' + String(this.props.colorMode === 'dark')}
            />
          </div>        
          <div className='txt'>
            <p>
              La suppression de l'obligation nationale de suivre des cours pourrait avoir entraîné une augmentation des morsures. En effet, l'augmentation du nombre de chiens en Suisse ne peut pas être la seule cause: le nombre de chiens n'a en effet augmenté que de 5% entre début 2016 et fin 2019. 
            </p>
            <p>
              Il est également possible que la population soit de nos jours plus sensible à la thématique des morsures. Plusieurs cantons mènent par ailleurs des campagnes de prévention et des projets scolaires pour éviter les morsures de chiens. Car les enfants ont un risque particulièrement élevé d'être mordus - d'ailleurs surtout par des petits chiens qui, selon les spécialistes, sont plus agressifs.
            </p>
          </div>
      </div>
    </div>
  }
}
